'use client';

import {useRouter} from "next/navigation";
import {Button, Layout, Result} from "antd";
import {Content} from "antd/es/layout/layout";

const NotFoundPage = () => {
    const router = useRouter();

    return (
        <Layout style={{minHeight: '100vh'}}>
            <Content style={{minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Result
                    status="404"
                    title="404"
                    subTitle="Извините, страница не найдена."
                    extra={
                        <Button type="primary" onClick={() => router.push('/')}>
                            На главную
                        </Button>
                    }
                />
            </Content>
        </Layout>
    );
};

export default NotFoundPage;